import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { obraAction } from '../../../../_actions'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import ConstructionIcon from '@mui/icons-material/Construction';
import {
  Avatar,
  Button,
  Fade,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Typography
} from '@mui/material';
import PropTypes from 'prop-types'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useSelector, useDispatch } from 'react-redux'
import { AccessControl } from '../../../../components/Utils/AccessControl'
import { STATUS_SERVICO, history } from '../../../../utils'
import { useDebounce } from 'use-debounce';
import Stars from '../../../../components/Stars/Stars';
import { brandBlue, brandBlueDark } from '../StatCard/StatCard'

const ToolTipFormatted = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 550,
    fontSize: 9,
    border: '1.2px solid #90b0cb',
  },
}));

const GridStyled = styled(Grid)(() => ({
  marginBottom: 8,
  padding: 2
}));

const SpanStyled = styled('span')({
  display: 'flex',
  flexDirection: 'row',
  alignContent: 'center'
});

const AvatarStyled = styled(Avatar)(() => ({
  width: 93,
  height: 93,
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center'
}));

const ButtonStyled = styled(Button)(() => ({
  paddingLeft: 5,
  paddingTop: 2,
  paddingBottom: 2,
  paddingRight: 5,
  backgroundColor: brandBlue,
  color: '#FFF',
  '&:hover': {
    backgroundColor: brandBlueDark,
    transition: '0.2s'
  },
}));

const PaperStyled = styled(Paper)(() => ({
  borderRadius: 14,
  border: '1px solid #e8ecf1',
  boxShadow: '0 2px 10px rgba(15, 23, 42, 0.05)',
  overflow: 'hidden'
}));

const HeaderStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: 16,
  padding: theme.spacing(2.5, 3),
  borderBottom: '1px solid #e8ecf1'
}));

const SearchField = styled(TextField)(() => ({
  width: 300,
  maxWidth: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: 10,
    backgroundColor: '#fafbfc',
    '&.Mui-focused fieldset': {
      borderColor: brandBlue
    }
  }
}));

const HeadCell = styled(TableCell)(() => ({
  backgroundColor: '#f7f9fc',
  color: '#6b7280',
  fontSize: 12,
  fontWeight: 600,
  letterSpacing: 0.4,
  textTransform: 'uppercase',
  borderBottom: '1px solid #e8ecf1'
}));

const UrgentBadge = styled('span')(() => ({
  backgroundColor: 'rgba(239, 83, 80, 0.12)',
  color: '#c62828',
  borderRadius: 999,
  padding: '3px 10px',
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: 0.3,
  marginRight: 8,
  whiteSpace: 'nowrap'
}));

const CardListaObraInteresse = (props) => {

  const dispatch = useDispatch()
  const { user } = useSelector(
    (state) => state.authentication)

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [term, setTerm] = useState('');
  const [debounceTerm] = useDebounce(term, 1000);
  const [order] = useState('data');
  const [direction] = useState('desc');

  const { obra, totalRegistros, isLoading } = useSelector(
    (state) => state.obra
  )

  const retornaStatusObra = (ultimoEvento) => {
    if (ultimoEvento == STATUS_SERVICO.LANCAMENTO) {
      return <span style={{ backgroundColor: '#000000', borderRadius: 8, padding: 4, color: '#fff', fontSize: 12, marginRight: 4, fontWeight: 400 }}>
        EM LANÇAMENTO
      </span>
    } else if (ultimoEvento == STATUS_SERVICO.PENDENTE) {
      return <span style={{ backgroundColor: '#9E9E9E', borderRadius: 8, padding: 4, color: '#fff', fontSize: 12, marginRight: 4, fontWeight: 400 }}>
        PENDENTE
      </span>
    } else if (ultimoEvento == STATUS_SERVICO.RECEBENDO_ORCAMENTOS) {
      return <span style={{ backgroundColor: '#673AB7', borderRadius: 8, padding: 4, color: '#fff', fontSize: 12, marginRight: 4, fontWeight: 400 }}>
        RECEBENDO PROPOSTAS
      </span>
    } else if (ultimoEvento == STATUS_SERVICO.ORCAMENTO_APROVADO) {
      return <span style={{ backgroundColor: '#2196F3', borderRadius: 8, padding: 4, color: '#fff', fontSize: 12, marginRight: 4, fontWeight: 400 }}>
        EM EXECUÇÃO
      </span>
    } else if (ultimoEvento == STATUS_SERVICO.RECUSADO) {
      return <span style={{ backgroundColor: '#ef5350', borderRadius: 8, padding: 4, color: '#fff', fontSize: 12, marginRight: 4, fontWeight: 400 }}>
        RECUSADA
      </span>
    } else if (ultimoEvento == STATUS_SERVICO.CONCLUIDO) {
      return <span style={{ backgroundColor: '#4CAF50', borderRadius: 8, padding: 4, color: '#fff', fontSize: 12, marginRight: 4, fontWeight: 400 }}>
        CONCLUÍDA
      </span>
    } else if (ultimoEvento == STATUS_SERVICO.AVALIADO) {
      return <span style={{ backgroundColor: '#FF9800', borderRadius: 8, padding: 4, color: '#fff', fontSize: 12, marginRight: 4, fontWeight: 400 }}>
        AVALIADA
      </span>
    }
  }

  useEffect(() => {

    const fetchData = (page, limit, term) => {

      let filterModel = {
        Page: page,
        Limit: limit,
        Term: term,
        Order: order,
        Direction: direction,
        Status: STATUS_SERVICO.RECEBENDO_ORCAMENTOS
      };

      dispatch(obraAction.getObra(filterModel, true));
    };

    fetchData(page, limit, debounceTerm, order, direction);

  }, [page, limit, debounceTerm, order, direction])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeLimit = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChange = prop => event => {
    setTerm(event.target.value);
  };

  return (
    <PaperStyled elevation={0}>
      <HeaderStyled>
        <div>
          <Typography sx={{ fontSize: 18, fontWeight: 700, color: '#111827' }}>Obras de Interesse</Typography>
          <Typography sx={{ fontSize: 14, color: '#6b7280' }}>Obras recebendo propostas no momento</Typography>
        </div>
        <SearchField
          id="term"
          size="small"
          placeholder="Buscar obra"
          value={term}
          onChange={handleChange('term')}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon sx={{ color: '#9ca3af' }} />
              </InputAdornment>
            )
          }}
        />
      </HeaderStyled>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="obras de interesse">
          <TableHead>
            <TableRow>
              <HeadCell>Título</HeadCell>
              <HeadCell align="center">Tipo de obra</HeadCell>
              <HeadCell align="center">Órgão</HeadCell>
              <HeadCell align="center">Nota</HeadCell>
              <HeadCell align="center"></HeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {obra && obra.length > 0 ? obra.map((o) => (
              <TableRow
                hover
                key={o.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {o.urgencia ? (
                      <UrgentBadge>OBRA URGENTE</UrgentBadge>
                    ) : null}
                    <ToolTipFormatted
                      placement="top-end"
                      TransitionComponent={Fade}
                      title={
                        <GridStyled container>
                          <Grid item lg={12} md={12} xl={12} xs={12}>
                            <Typography color="inherit" align="center"><b>Detalhes da Obra</b></Typography>
                          </Grid>
                          <Grid container>
                            <Grid item lg={3} md={3} xl={3} xs={12} align="center">
                              {o.caminhoImagem ?
                                <AvatarStyled variant="rounded"
                                  src={o.caminhoImagem}
                                />
                                :
                                <AvatarStyled variant="rounded">
                                  <ConstructionIcon sx={{ fontSize: 40 }} />
                                </AvatarStyled>
                              }
                            </Grid>
                            <Grid item lg={9} md={9} xl={9} xs={12} style={{ display: 'flex', flexDirection: 'column' }}>
                              <SpanStyled><Typography sx={{ fontSize: 12 }} color="inherit" align="left"><b>Título:</b>&nbsp;{o.titulo?.toUpperCase()}</Typography></SpanStyled>
                              <SpanStyled><Typography sx={{ fontSize: 12 }} color="inherit" align="left"><b>Descritivo:</b>&nbsp;{o.descritivo?.toUpperCase()}</Typography></SpanStyled>
                              <SpanStyled><Typography sx={{ fontSize: 12 }} color="inherit" align="left"><b>Status:</b>&nbsp;{retornaStatusObra(o.ultimoEvento)}</Typography></SpanStyled>
                              <SpanStyled><Typography sx={{ fontSize: 12 }} color="inherit" align="left"><b>BDI:</b>&nbsp;{o.bdi ? o.bdi + '%' : 'SEM BDI'}</Typography></SpanStyled>
                              <SpanStyled><Typography sx={{ fontSize: 12 }} color="inherit" align="left"><b>Valor referência:</b>&nbsp;R$ {o.valorReferenciaComBdi ? o.valorReferenciaComBdi.toLocaleString('pt-br', { minimumFractionDigits: 2 }) : '0,00'}</Typography></SpanStyled>
                            </Grid>
                          </Grid>
                          <Grid item lg={12} md={12} xl={12} xs={12} align="center">
                            <ButtonStyled onClick={() => history.push(`/obra/` + o.id)} size="small">Ver mais</ButtonStyled>
                          </Grid>
                        </GridStyled>
                      }
                    >
                      <span style={{ verticalAlign: 'middle', fontWeight: 500, color: '#111827', cursor: 'default' }}> {o.titulo ? `#${o.id} ` + o.titulo.toUpperCase() : ''}</span>
                    </ToolTipFormatted>
                  </div>
                </TableCell>
                <TableCell align="center" sx={{ color: '#4b5563' }}>{o.tipoObra?.nome?.toUpperCase()}</TableCell>
                <TableCell align="center" sx={{ color: '#4b5563' }}>{o.orgao?.nome?.toUpperCase()}</TableCell>
                <TableCell align="center">{<Stars mediaNota={o.obrasAvaliacoes && o.obrasAvaliacoes[0]?.nota} avaliacoes={1} />}</TableCell>
                <TableCell align="center"><AccessControl
                  rule={'obras.list'} //permissão necessária para acessar conteúdo
                  yes={() => (
                    <IconButton
                      aria-label="Visualizar"
                      component="a"
                      onClick={() =>
                        history.push(`/obra/${o.id}`)
                      }
                      size="small"
                      sx={{ color: brandBlue, '&:hover': { backgroundColor: 'rgba(1, 81, 146, 0.08)' } }}
                    >
                      <Tooltip title={'Visualizar obra'}>
                        <VisibilityOutlinedIcon />
                      </Tooltip>
                    </IconButton>
                  )}
                /></TableCell>
              </TableRow>
            )) :
              (
                !isLoading ?
                  <TableRow>
                    <TableCell rowSpan={3} colSpan={5} align="center" sx={{ py: 5, color: '#6b7280' }}>Nenhum registro encontrado</TableCell>
                  </TableRow>
                  :
                  Array.apply(null, { length: 5 }).map((e, i) => (
                    <TableRow hover key={i}>
                      <TableCell component="th" scope="row">
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <Skeleton animation="wave" />
                      </TableCell>
                    </TableRow>
                  ))
              )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={totalRegistros}
        labelRowsPerPage="Linhas por página"
        labelDisplayedRows={({ from, to }) => `${from}-${to} de ${totalRegistros}`}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={limit}
        onRowsPerPageChange={handleChangeLimit}
        sx={{ borderTop: '1px solid #e8ecf1' }}
      />
    </PaperStyled>
  );
}

CardListaObraInteresse.propTypes = {
  className: PropTypes.string,
  subtitle: PropTypes.string
}

export default CardListaObraInteresse
